/**
 * The translator bound to the signed-in partner's language (P0-BR4).
 *
 * `users.language` is stored per partner, so one can read the app in Bangla
 * while another reads it in English. Before sign-in, and for anyone who has
 * not chosen, Bangla is the default (NFR-6).
 */

import { useMemo } from 'react';

import { useAuth } from '../features/auth/AuthContext.js';
import { DEFAULT_LOCALE, translatorFor, type Locale, type TranslateOptions, type TranslationKey } from './index.js';

export interface Translation {
  locale: Locale;
  t: (key: TranslationKey | string, options?: TranslateOptions) => string;
}

export function useTranslation(): Translation {
  const { user } = useAuth();
  const locale: Locale = user?.language ?? DEFAULT_LOCALE;

  return useMemo(() => ({ locale, t: translatorFor(locale) }), [locale]);
}
